// src/context/CastleSkinContext.jsx
import React, { createContext, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import {
  DEFAULT_CASTLE_SKIN_ID,
  getCastleSkinMobileUrl,
} from '../constants/skins';
import { isMobileAppRuntime } from '../config/mobileRuntime';
import { preloadCastleSkinUrl } from '../utils/castleSkinAssets';

export const CastleSkinContext = createContext();

export function CastleSkinProvider({ children }) {
  // ❶ читаем последнюю выбранную тему из localStorage
  const initialSkinId = localStorage.getItem('castle_skin') || DEFAULT_CASTLE_SKIN_ID;
  const [skinId, setSkinId] = useState(initialSkinId);

  // ❷ кеш full-изображений на весь сеанс
  const imageCache = useRef({});

  // Warm the active full-size castle as soon as the native application starts,
  // rather than waiting until the user navigates to the Vault page. The asset
  // response is immutable and retained by the WebView HTTP cache across app
  // launches, while preloadCastleSkinUrl also deduplicates work in this session.
  useEffect(() => {
    if (!isMobileAppRuntime()) return;
    void preloadCastleSkinUrl(getCastleSkinMobileUrl(skinId)).catch(() => {});
  }, [skinId]);

  // ❸ helper для обновления
  const updateSkin = useCallback((newId) => {
    setSkinId(newId);
    localStorage.setItem('castle_skin', newId);
  }, []);

  const value = useMemo(
    () => ({ skinId, updateSkin, imageCache }),
    [skinId, updateSkin]
  );

  return (
    <CastleSkinContext.Provider value={value}>
      {children}
    </CastleSkinContext.Provider>
  );
}
